import { RefObject, useRef, useState } from 'react';
import { burstLikeConfetti } from 'utils/like-confetti';

export function useLikeAnimation<T extends HTMLElement = HTMLElement>(animationTargetRef?: RefObject<HTMLElement>) {
  const ref = useRef<T>(null);
  const [isPopping, setIsPopping] = useState(false);

  const trigger = () => {
    const target = animationTargetRef?.current ?? ref.current;

    if (!target) {
      return;
    }

    const rect = target.getBoundingClientRect();

    burstLikeConfetti(rect.left + rect.width / 2, rect.top + rect.height / 2);
    setIsPopping(true);
    setTimeout(() => setIsPopping(false), 400);
  };

  return { ref, isPopping, trigger };
}
